module.exports = __webpack_public_path__ + "static/img/tjsp5.3bde5f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/tjsp5.png
// module id = 392
// module chunks = 0